import { Card } from '@ipfabric/ui-components/Card/Card';
import { Table } from 'components/Table/components/Table';
import { renderQuery } from 'utils/react-query/renderQuery';
import { LabelForm } from './LabelForm';
import { useLabelsTable } from './useLabelsTable';

const labelsTableDescription =
  'Create labels to tag and group devices and interfaces in your network. ' +
  'Each label has a name and optional predefined values (for example a region label with values uk, usa, cz), ' +
  'or can be a simple tag without values. Once defined, labels can be assigned to inventory objects ' +
  'and used in table filters and intent checks.';

export const LabelsTabContent = () => {
  const labelsTable = useLabelsTable();
  const closeLabelForm = () => {
    labelsTable.setEditedLabel(null);
  };
  const saveLabelForm = () => {
    void labelsTable.invalidateLabels();
    labelsTable.setEditedLabel(null);
  };

  return (
    <Card className='flex flex-col flex-1 rounded-tl-none min-h-0' noShadow>
      {renderQuery({
        query: labelsTable.labelsQuery,
        renderStaleDataOnMount: true,
        success: () => (
          <Table
            borderless
            bulkActions={labelsTable.bulkActions}
            className='flex-1 bg-transparent'
            columns={labelsTable.columns}
            description={labelsTableDescription}
            disableTableRowDetail
            loadRowIdsForSelectAll='fromData'
            menuItems={labelsTable.menuItems}
            rowHeight={44}
            rowIdField='id'
            title='Labels'
            {...labelsTable.frontendSimpleFilter}
          />
        ),
      })}
      {labelsTable.confirmDeleteDialog.render()}
      {labelsTable.editedLabel === 'new' ? (
        <LabelForm
          formType='add'
          onClose={closeLabelForm}
          onSave={saveLabelForm}
        />
      ) : labelsTable.editedLabel !== null ? (
        <LabelForm
          formType='edit'
          label={labelsTable.editedLabel}
          onClose={closeLabelForm}
          onSave={saveLabelForm}
        />
      ) : null}
    </Card>
  );
};
